import { createApi } from '../callApi';
const contentApi = createApi('CONTENT');

export const updatePlayerSettings = (show, body) => {
    return contentApi({ method: 'PUT', target: `/v1/shows/${show}/widget/settings`, body });
};
export const fetchPlayerSettings = (show) => {
    return contentApi({ method: 'GET', target: `/v1/shows/${show}/widget/settings` });
};
